export default __webpack_public_path__ + "static/notification-31a9d1dd4daf6d35ac6d257f486f05c1.png";